var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-component",class:{ 'disabled-image-action': _vm.disabled },style:({ 'background-color': _vm.bg })},[(_vm.isButtun)?_c('img',{staticClass:"btn btn-sm p-0 img-btn",attrs:{"src":_vm.url,"alt":'path image cars'}}):_c('img',{staticClass:"btn btn-sm p-0 img-btn",attrs:{"src":_vm.url,"alt":'path image cars'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }